import React from 'react'
import NavigationCard from '../ui/NavigationCard/NavigationCard'
import styles from './NavigationCards.module.scss'
import classNames from 'classnames'

const NavigationCards = ({ navigations = [], className }) => {
  return (
    <div
      className={classNames(
        styles['navigations-wrapper'],
        `grid grid-cols-1 md:grid-cols-${navigations?.length === 0 ? 1 : navigations.length} gap-3`,
        className
      )}
    >
      {navigations?.map((nav) => {
        return (
          <div key={'nav' + nav?.id}>
            <NavigationCard navigation={nav} />
          </div>
        )
      })}
    </div>
  )
}

export default NavigationCards
